// Firebase Configuration for Web App
// DO NOT commit this file with actual Firebase config to version control if it contains sensitive data
// Add this file to .gitignore to keep your Firebase credentials secure

/**
 * Firebase Configuration
 * 
 * To use this configuration:
 * 1. Create a Firebase project at https://console.firebase.google.com/
 * 2. Get your Firebase config from Project Settings > General > Your apps
 * 3. Replace the placeholder values below with your actual Firebase config
 * 4. Ensure this file is in .gitignore if needed
 * 5. Import this module in files that need Firebase access:
 *    import { FIREBASE_CONFIG } from './firebase-config.js';
 */

export const FIREBASE_CONFIG = {
  // Firebase project configuration
  // Get this from: Firebase Console > Project Settings > General > Your apps
  apiKey: "AIzaSyDIaX0pF6PNEd1zWF7bcN1EeWM_thonDoM",
  authDomain: "fastenai-1.firebaseapp.com",
  projectId: "fastenai-1",
  storageBucket: "fastenai-1.firebasestorage.app",
  messagingSenderId: "397058698176",
  appId: "1:397058698176:web:c97b01ff6c28f1ff947625",
  measurementId: "G-WRHT8KX0G6"
};

// Firebase project ID and function name
export const FIREBASE_PROJECT_ID = 'fastenai-1';
export const GEMINI_FUNCTION_NAME = 'chatGemini';
// Cloud Run URL for v2 (2nd Gen) functions
export const CHAT_GEMINI_URL = 'https://chatgemini-dyxw4vknaa-uc.a.run.app';

